const Source = {
  name: 'source',
  label: I.gt.__('Source'),
  title: I.gt.__('Source'),
  method: 'toggleSource',
  icon: 'code',
}

const ClearAll = {
  name: 'clearAll',
  title: I.gt.__('Clear all'),
  method: 'clearAll',
  icon: 'trash',
}

const Cut = {
  name: 'cut',
  title: `${I.gt.__('Cut')} ${I.gt.__('(Ctrl + X)')}`,
  method: 'icut',
  icon: 'cut'
}

const Copy = {
  name: 'copy',
  title: `${I.gt.__('Copy')} ${I.gt.__('(Ctrl + C)')}`,
  method: 'copy',
  icon: 'copy'
}

const Paste = {
  name: 'paste',
  title: `${I.gt.__('Paste')} ${I.gt.__('(Ctrl + V)')}`,
  method: 'paste',
  icon: 'paste'
}

const PastePlain = {
  name: 'paste-plain',
  title: `${I.gt.__('Paste as plain text')} ${I.gt.__('(Ctrl + Shift + V)')}`,
  method: 'pastePlain',
  icon: 'paste'
}

const Print = {
  name: 'print',
  title: I.gt.__('Print'),
  method: 'print',
  icon: 'print'
}

const SpellCheck = {
  name: 'spell-check',
  title: I.gt.__('Spell check'),
  method: 'toggleSpellCheck',
  icon: 'spell-check',
  active: (editor) => { return editor.view.dom.spellcheck },
}

const Undo = {
  name: 'undo',
  title: `${I.gt.__('Undo')} ${I.gt.__('(Ctrl + Z)')}`,
  method: 'undo',
  icon: 'undo'
}

const Redo = {
  name: 'redo',
  title: `${I.gt.__('Redo')} ${I.gt.__('(Ctrl + Y)')}`,
  method: 'redo',
  icon: 'redo'
}

const Find = {
  name: 'find',
  type: 'search',
};

const SelectAll = {
  name: 'selectAll',
  title: I.gt.__('Select All'),
  method: 'selectAll',
  icon: 'check-square'
}

const RemoveFormat = {
  name: 'removeFormat',
  title: I.gt.__('Remove format'),
  method: 'removeFormat',
  icon: 'text-slash'
}

const Bold = {
  name: 'bold',
  title: `${I.gt.__('Bold')} ${I.gt.__('(Ctrl + B)')}`,
  method: 'toggleBold',
  icon: 'bold'
}

const Italic = {
  name: 'italic',
  title: `${I.gt.__('Italic')} ${I.gt.__('(Ctrl + I)')}`,
  method: 'toggleItalic',
  icon: 'italic'
}

const Underline = {
  name: 'underline',
  title: `${I.gt.__('Underline')} ${I.gt.__('(Ctrl + U)')}`,
  method: 'toggleUnderline',
  icon: 'underline'
}

const Strike = {
  name: 'strike',
  title: I.gt.__('Strikethrough'),
  method: 'toggleStrike',
  icon: 'strikethrough'
}

const Subscript = {
  name: 'subscript',
  title: I.gt.__('Subscript'),
  method: 'toggleSubscript',
  icon: 'subscript'
}

const Superscript = {
  name: 'superscript',
  title: I.gt.__('Superscript'),
  method: 'toggleSuperscript',
  icon: 'superscript'
}

const OrderedList = {
  name: 'orderedList',
  title: I.gt.__('Insert/Remove Numbered List'),
  method: 'toggleOrderedList',
  icon: 'list-ol'
}

const BulletList = {
  name: 'bulletList',
  title: I.gt.__('Insert/Remove Bulleted List'),
  method: 'toggleBulletList',
  icon: 'list'
}

const DecreaseIndent = {
  name: 'decreaseIndent',
  title: I.gt.__('Decrease Indent'),
  method: 'decreaseIndent',
  icon: 'outdent'
}

const IncreaseIndent = {
  name: 'increaseIndent',
  title: I.gt.__('Increase Indent'),
  method: 'increaseIndent',
  icon: 'indent'
}

const Blockquote = {
  name: 'blockquote',
  title: I.gt.__('Block Quote'),
  method: 'toggleBlockquote',
  icon: 'block-quote'
}

const TextAlignLeft = {
  name: 'textAlign',
  title: I.gt.__('Align Left'),
  method: 'setTextAlign',
  options: 'left',
  icon: 'align-left'
}

const TextAlignCenter = {
  name: 'textAlign',
  title: I.gt.__('Center'),
  method: 'setTextAlign',
  options: 'center',
  icon: 'align-center'
}

const TextAlignRight = {
  name: 'textAlign',
  title: I.gt.__('Align Right'),
  method: 'setTextAlign',
  options: 'right',
  icon: 'align-right'
}

const TextAlignJustify = {
  name: 'textAlign',
  title: I.gt.__('Justify'),
  method: 'setTextAlign',
  options: 'justify',
  icon: 'align-justify'
}

const TextDirectionLtr = {
  name: 'direction',
  title: I.gt.__('Text direction from left to right'),
  method: 'setTextDirection',
  options: 'ltr',
  icon: 'chevron-left'
}

const TextDirectionRtl = {
  name: 'direction',
  title: I.gt.__('Text direction from right to left'),
  method: 'setTextDirection',
  options: 'rtl',
  icon: 'chevron-right'
}

const Image = {
  name: 'image',
  title: I.gt.__('Insert an asset from the MAM'),
  method: 'openImageModal',
  icon: 'image'
}

const Link = {
  name: 'link',
  title: I.gt.__('Create link'),
  method: 'openLinkModal',
  icon: 'link'
}

const Unlink = {
  name: 'unlink',
  title: I.gt.__('Remove link'),
  method: 'removeLink',
  icon: 'link-slash'
}

const Table = {
  name: 'table',
  title: I.gt.__('Table'),
  type: 'table',
}

const HorizontalRule = {
  name: 'horizontalRule',
  title: I.gt.__('Insert horizontal line'),
  method: 'setHorizontalRule',
  icon: 'minus',
}

const Format = {
  name: 'format',
  selection: 'getSelectedNodeType',
  title: I.gt.__('Format'),
  type: 'dropdown',
  options: [
    { label: 'Paragraph', method: 'setParagraph', selectedNode: 'paragraph' },
    { label: 'Heading 1', method: 'toggleHeading', options: { level: 1 }, selectedNode: 'heading' },
    { label: 'Heading 2', method: 'toggleHeading', options: { level: 2 }, selectedNode: 'heading' },
    { label: 'Heading 3', method: 'toggleHeading', options: { level: 3 }, selectedNode: 'heading' },
    { label: 'Heading 4', method: 'toggleHeading', options: { level: 4 }, selectedNode: 'heading' },
    { label: 'Heading 5', method: 'toggleHeading', options: { level: 5 }, selectedNode: 'heading' },
    { label: 'Heading 6', method: 'toggleHeading', options: { level: 6 }, selectedNode: 'heading' }
  ]
}

const Styles = {
  name: 'styles',
  selection: 'getSelectedStyles',
  title: I.gt.__('Custom Styles'),
  type: 'dropdown',
  options: [
    { label: 'Div', method: 'setCustomStyle', options: { element: 'div', attrs: { class: 'panel' }} },
    { label: 'Check-Liste', method: 'setCustomStyle', options: { element: 'bulletList', attrs: { class: 'checklist' }} },
    { label: 'Plus-Liste', method: 'setCustomStyle', options: { element: 'bulletList', attrs: { class: 'plus' }} },
    { label: 'Link-Style', method: 'setCustomStyle', options: { element: 'link', attrs: { class: 'link' }} },
    { label: 'Intro', method: 'setCustomStyle', options: { element: 'paragraph', attrs: { class: 'intro' }} },
    { label: 'Marker', method: 'setCustomStyle', options: { element: 'textStyle', attrs: { class: 'marker' }} },
    { label: 'Italic Title', method: 'setCustomStyle', options: { element: 'heading', attrs: { level: 2, style: 'font-style: italic;' }} },
  ]
}

const StyleCurrent = {
  name: 'styleCurrent',
  selection: 'getSelectedStyles',
  title: I.gt.__('Style element'),
  type: 'dropdown',
  filtered: true,
  options: [
    { label: 'Check-Liste', method: 'setCustomStyle', options: { element: 'bulletList', attrs: { class: 'checklist' }} },
    { label: 'Plus-Liste', method: 'setCustomStyle', options: { element: 'bulletList', attrs: { class: 'plus' }} },
    { label: 'Link-Style', method: 'setCustomStyle', options: { element: 'link', attrs: { class: 'link' }} },
    { label: 'Intro', method: 'setCustomStyle', options: { element: 'paragraph', attrs: { class: 'intro' }} },
    { label: 'Marker', method: 'setCustomStyle', options: { element: 'textStyle', attrs: { class: 'marker' }} },
    { label: 'Italic Title', method: 'setCustomStyle', options: { element: 'heading', attrs: { level: 2, style: 'font-style: italic;' }} },
  ]
}

const Font = {
  name: 'font',
  selection: 'getFontFamily',
  label: I.gt.__('Font'),
  title: I.gt.__('Font Name'),
  type: 'dropdown',
  options: [
    { label: 'Default', method: 'setFontFamily' },
    { label: 'Arial', method: 'setFontFamily', options: 'Arial,Helvetica,sans-serif' },
    { label: 'Monospace', method: 'setFontFamily', options: 'monospace' },
    { label: 'Times New Roman', method: 'setFontFamily', options: '"Times New Roman",Times,serif' },
    { label: 'Georgia', method: 'setFontFamily', options: 'Georgia,serif' },
    { label: 'Verdana', method: 'setFontFamily', options: 'Verdana,Geneva,sans-serif' },
    { label: 'Tahoma', method: 'setFontFamily', options: 'Tahoma,Geneva,sans-serif' },
    { label: 'Courier New', method: 'setFontFamily', options: '"Courier New",Courier,monospace' },
    {
      label: 'Palatino',
      method: 'setFontFamily',
      options: '"Palatino Linotype","Book Antiqua",Palatino,serif'
    },
    { label: 'Garamond', method: 'setFontFamily', options: 'Garamond,serif' },
    {
      label: 'Comic Sans MS',
      method: 'setFontFamily',
      options: '"Comic Sans MS",cursive,sans-serif'
    },
    {
      label: 'Trebuchet MS',
      method: 'setFontFamily',
      options: '"Trebuchet MS",Helvetica,sans-serif'
    }
  ]
}

const FontSize = {
  name: 'fontSize',
  selection: 'getFontSize',
  label: I.gt.__('Size'),
  title: I.gt.__('Font Size'),
  type: 'dropdown',
  options: [
    { label: 'Default', method: 'setFontSize' },
    { label: '8px', method: 'setFontSize', options: '8px' },
    { label: '9px', method: 'setFontSize', options: '9px' },
    { label: '10px', method: 'setFontSize', options: '10px' },
    { label: '12px', method: 'setFontSize', options: '12px' },
    { label: '14px', method: 'setFontSize', options: '14px' },
    { label: '16px', method: 'setFontSize', options: '16px' },
    { label: '18px', method: 'setFontSize', options: '18px' },
    { label: '20px', method: 'setFontSize', options: '20px' },
    { label: '22px', method: 'setFontSize', options: '22px' },
    { label: '24px', method: 'setFontSize', options: '24px' },
    { label: '26px', method: 'setFontSize', options: '26px' },
    { label: '28px', method: 'setFontSize', options: '28px' },
    { label: '36px', method: 'setFontSize', options: '36px' },
    { label: '48px', method: 'setFontSize', options: '48px' },
    { label: '72px', method: 'setFontSize', options: '72px' }
  ]
}

const Highlight = {
  name: 'hightlight',
  title: I.gt.__('Highlight'),
  method: 'toggleHighlight',
  icon: 'plus',
}

const Info = {
  name: 'info',
  title: I.gt.__('Info'),
  method: 'showInfo',
  icon: 'circle-info',
}

export const MENUBAR_DEFINITIONS = {
  Source,
  ClearAll,
  Cut,
  Copy,
  Paste,
  PastePlain,
  Print,
  SpellCheck,
  Undo,
  Redo,
  Find,
  SelectAll,
  RemoveFormat,
  Bold,
  Italic,
  Underline,
  Strike,
  Subscript,
  Superscript,
  OrderedList,
  BulletList,
  DecreaseIndent,
  IncreaseIndent,
  Blockquote,
  TextAlignLeft,
  TextAlignCenter,
  TextAlignRight,
  TextAlignJustify,
  TextDirectionLtr,
  TextDirectionRtl,
  Image,
  Link,
  Unlink,
  Table,
  HorizontalRule,
  Format,
  Styles,
  StyleCurrent,
  Font,
  FontSize,
  Highlight,
  Info,
};


const LINK_CONTEXT_MENU = {
  name: 'link_context_menu',
  show: (editor, config) => {
    return editor.isActive('link');
  },
  items: {
    Link, Unlink,
  },
}

const TABLE_CONTEXT_MENU = {
  name: 'table_context_menu',
  show: (editor, config) => {
    return editor.isActive('tableRow');
  },
  items: {
    AddColumnAfter: {
      name: "addColumnAfter",
      icon: "table-columns",
      method: "addColumnAfter",
      title: "Add Column After"
    },
    DeleteColumn: {
      name: "deleteColumn",
      icon: "delete-left",
      method: "deleteColumn",
      title: "Delete Column"
    },
    AddRowAfter: {
      name: "addRowAfter",
      icon: "table-rows",
      method: "addRowAfter",
      title: "Add Row After"
    },
    DeleteRow: {
      name: "deleteRow",
      icon: "delete-right",
      method: "deleteRow",
      title: "Delete Row"
    },
    MergeCells: {
      name: "mergeCells",
      icon: "object-group",
      method: "mergeCells",
      title: "Merge Cells"
    },
    SplitCell: {
      name: "splitCell",
      icon: "object-ungroup",
      method: "splitCell",
      title: "Split Cell"
    },
    ToggleHeaderColumn: {
      name: "toggleHeaderColumn",
      icon: "grip-lines-vertical",
      method: "toggleHeaderColumn",
      title: "Toggle Header Column"
    },
    ToggleHeaderRow: {
      name: "toggleHeaderRow",
      icon: "grip-lines",
      method: "toggleHeaderRow",
      title: "Toggle Header Row"
    },
    ToggleHeaderCell: {
      name: "toggleHeaderCell",
      icon: "border-all",
      method: "toggleHeaderCell",
      title: "Toggle Header Cell"
    },
    DeleteTable: {
      name: "deleteTable",
      icon: "trash-alt",
      method: "deleteTable",
      title: "Delete Table"
    }
  }
}

export const CONTEXT_MENUS = {
  LINK_CONTEXT_MENU,
  TABLE_CONTEXT_MENU
}

// MVP_CONFIG
export const TIPTAP_CONFIG = {
  width: '100%',
  height: '600px',
  resizable: true,
  spellcheck: false,
  sourceModeType: 'html',
  canInspect: true,
  bubbleMenu: true,
  bundle: 'full',
}

export const FEATURE_BUNDLES = {
  fallback: {
    menubar: [
      Source, '-', Undo, Redo, '-', Cut, Copy, Paste, PastePlain, '-',
      ClearAll, '-', Bold, Italic, Underline, Strike, Subscript, Superscript, '-',
      OrderedList, BulletList, '-', DecreaseIndent, IncreaseIndent, '-',
      Blockquote, '-', TextAlignLeft, TextAlignCenter, TextAlignRight, TextAlignJustify, '-',
      TextDirectionLtr, TextDirectionRtl, '-', Link, Unlink, '-', Image, '-',
      Table, HorizontalRule, '-', Format, Styles, '-', Info
    ],
    extensions: {
      'StarterKit': {
        history: true,
        codeBlock: true,
        link: false,
      },
      'Strike': {},
      'Subscript': {},
      'Superscript': {},
      'TextStyleKit': {},
      'ClassAttribute': {},
      'Indent': { types: ['paragraph', 'heading'] },
      'TextDirection': { types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem'] },
      'TextAlign': { types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem'] },
      'Table': { resizable: true },
      'TableCell': {},
      'TableHeader': {},
      'TableRow': {},
      'MAMImage': { inline: true },
      'MAMLink': { openOnClick: false },
      'Paste': {},
    }
  },
  minimal: {
    menubar: [
      Source,
      '-', Undo, Redo,
      '-', Cut, Copy, Paste, PastePlain,
      '-', Format, Styles, StyleCurrent,
      '-', OrderedList, BulletList,
      '-', TextAlignLeft, TextAlignCenter, TextAlignRight,
      '-', Bold, Italic,
      '-', Link,
      '-', Info
    ],
    extensions: {
      'StarterKit': {},
      'ClassAttribute': {},
      'Paste': {},
      'MAMLink': {
        openOnClick: false,
      },
      'TextAlign': {
        types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem']
      },
      'TextStyleKit': {},
    }
  },
  full: {
    contextMenus: [TABLE_CONTEXT_MENU, LINK_CONTEXT_MENU],
    menubar: [
      Source, '-', ClearAll, '-',
      Cut, Copy, Paste, PastePlain, '-', Print, SpellCheck, '-',
      Undo, Redo, '-', Find, '-',
      SelectAll, RemoveFormat,
      '/',
      Bold,
      Italic,
      Underline,
      Strike,
      '-',
      Subscript,
      Superscript,
      '-',
      OrderedList,
      BulletList,
      '-',
      DecreaseIndent,
      IncreaseIndent,
      Blockquote,
      '-',
      TextAlignLeft,
      TextAlignCenter,
      TextAlignRight,
      TextAlignJustify,
      '-',
      TextDirectionLtr,
      TextDirectionRtl,
      '-',
      Image,
      Link,
      Unlink,
      '-',
      Table,
      HorizontalRule,
      '/',
      Styles,
      '-',
      Format,
      '-',
      Font,
      '-',
      FontSize,
      '-',
      Info,
    ],
    extensions: {
      'StarterKit': {
        link: false,
      },
      'Markdown': {},
      'ClassAttribute': {},
      'TextStyleKit': {
        backgroundColor: {
          types: ['textStyle'],
        },
        color: {
          types: ['textStyle'],
        },
        fontFamily: {
          types: ['textStyle'],
        },
        fontSize: {
          types: ['textStyle'],
        },
        lineHeight: {
          types: ['textStyle'],
        },
      },
      'Div': {},
      'MAMfigure': {},
      'MAMLink': {
        defaultProtocol: 'https://',
        openOnClick: false,
        protocols: [
          {
            scheme: 'http'
          },
          {
            scheme: 'https'
          },
          {
            scheme: 'ftp'
          },
          {
            scheme: 'news'
          },
          { 
            scheme: 'javascript', 
            optionalSlashes: true 
          },
          {
            scheme: 'mailto',
            optionalSlashes: true
          },
        ],
      },
      'Subscript': {},
      'Superscript': {},
      'SearchAndReplace': {},
      'Table': {
        resizable: true
      },
      'TableCell': {},
      'TableHeader': {},
      'TableRow': {},
      'MAMImage': { 
        inline: true 
      },
      'Indent': {
        types: ['paragraph', 'heading']
      },
      'TextDirection': {
        types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem']
      },
      'TextAlign': {
        types: ['heading', 'paragraph', 'bulletList', 'orderedList', 'listItem']
      },
      'Paste': {},
    }
  }
}